export interface MotItemDTO {
  motHistoryId?: string;
  text?: string;
  type?: string;
}
